import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InvoiceLineItem from "./InvoiceLineItem";
import type Organisation from "./Organisation";
import type { InvoiceLedger, InvoiceStatus } from "./types";
import type User from "./User";

type InvoiceType = "contract" | "usage";

@Model()
class Invoice extends ApplicationRecord {
  static jsonapiType = "invoices";

  @Attr({ persist: false }) approvedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) from: string;

  @Attr() invoiceDate: string;

  @HasMany() invoiceLineItems: InvoiceLineItem[];

  @Attr() invoiceType: InvoiceType;

  @Attr() ledger: InvoiceLedger;

  @Attr() notes: string;

  @BelongsTo() organisation: Organisation;

  @BelongsTo() reviewer: User;

  @Attr() signedAttachmentUrl: string;

  @Attr() status: InvoiceStatus;

  @Attr({ persist: false }) to: string;

  @Attr({ persist: false }) totalCost: number;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() writeOffReason: string;

  reviewerName() {
    if (!this.reviewer) return "";

    return this.reviewer.name;
  }
}

export default Invoice;
